import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SessionService } from 'src/app/services/session.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AwsSupplierManagementService {

  constructor(
    private http: HttpClient, 
    private sessionService: SessionService
  ) { }

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'client-id':'apliclientesksks',
      'client-hash':'apliclientesksks',
      'Auth': this.sessionService.token
    })
  };

  private httpOptionsNew = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.sessionService.token}`
    })
  };

  //Dependencia panel de empresas​
  dependencyCompanySupplierPanel(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/dependency`, body , this.httpOptionsNew);
  }

  //Paginación panel de empresas
  listSuppliers(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/pagination`, body, this.httpOptionsNew);
  }

  //Gráfico panel de empresas
  listSuppliersLevels(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/graphic`, body, this.httpOptionsNew);
  }

  //Descargar excel panel de empresas​
  getFileXlsxProviders(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/download`, body, this.httpOptionsNew);
  }

  //Actualizar columnas del panel de empresas
  updateColumnsCompanySuppliersPanel(body){
    return this.http.put(`${environment.baseUrlAPIPlatform}/company/panel/updateColumns`, body, this.httpOptionsNew);
  }

  //Validación perfil de la empresa
  validateStateForm(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/validateProfile`, body, this.httpOptionsNew);
  }

  //Actualizar código de proveedor​
  updateCodeSupplierCompany(body){
    return this.http.put(`${environment.baseUrlAPIPlatform}/company/panel/updateCodeSupplier`, body, this.httpOptionsNew);
  }

  //Notificaciones de la empresa​
  listarNotificationSended(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/notifications`, body, this.httpOptionsNew);
  }

  //Solicitudes de notificaciones de la empresa
  listarNotificationRequest(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/notification/requests`, body, this.httpOptionsNew);
  }

  //Crear solicitud de notificacion de la empresa
  createNotificationRequest(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/notification/request/create`, body, this.httpOptionsNew);
  }

  //Eliminar solicitud de notificacion de la empresa
  eliminarNotificationRequest(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.sessionService.token}`
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPIPlatform}/company/panel/notification/request/delete`, httpOptionsTemp);
  }

  //Lista invitaciones a proveedores
  listInviteCompanies(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/supplierManagement/invitations`, body , this.httpOptionsNew);
  }

  //Lista invitaciones a proveedores
  inviteSupplier(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/supplierManagement/invitations`, body , this.httpOptionsNew);
  }

  //Eliminar proveedor​
  removeCompanySupplier(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/supplierManagement/delete`, body , this.httpOptionsNew);
  }

  //Lista solicitudes de formatos requeridos​
  documentApprovalRequestList(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/requiredFormats/list`, body , this.httpOptionsNew);
  }

  //Proveedores de un formato requerido
  documentApprovalRequestSuppliers(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/requiredFormats/suppliers`, body , this.httpOptionsNew);
  }

  //Crear solicitud de formato requerido​
  documentApprovalRequest(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/requiredFormats/create`, body , this.httpOptionsNew);
  }

  //Eliminar solicitud de formato requerido
  documentApprovalRequestDelete(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.sessionService.token}`
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPIPlatform}/company/panel/requiredFormats/delete`, httpOptionsTemp);
  }

  //Perfil del proveedor
  getCompanySupplier(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/summary/profile`, body, this.httpOptionsNew);
  }

  //Detalle del proveedor
  getCompanySupplierDetail(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/summary/detail`, body, this.httpOptionsNew);
  }

  //Logs del proveedor
  supplierManagementLog(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/summary/getLogs`, body, this.httpOptionsNew);
  }

  //Contactos del proveedor​
  supplierManagementContact(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/summary/contact`, body, this.httpOptionsNew);
  }

  //Logs estados del proveedor​
  listStatusCompanySupplier(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/summary/status/logs`, body, this.httpOptionsNew);
  }

  //Políticas del proveedor​
  listPoliciesCompanySupplier(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/summary/policies`, body, this.httpOptionsNew);
  }

  //Formatos del proveedor​
  requiredFormatsSupplierList(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/summary/formats/list`, body, this.httpOptionsNew);
  }

  //Etiquetas del proveedor​
  getCompanySupplierTags(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/summary/tags/list`, body, this.httpOptionsNew);
  }
  
  //listar dependencias proveedores de una empresa premium
  listDependencySuppliers(){
    return this.http.post(`${environment.baseUrlAPI}/user/listCompanySecoundCategoriesCBN`, {},  this.httpOptions);
  }

  getItemsAccountBank(body){
    return this.http.post(`${environment.baseUrlAPI}/user/getCompanyBankAccounts`, body,  this.httpOptions);
  }

  technicalReportDocx(body){
    return this.http.post(`${environment.baseUrlAPI}/company/technicalReportDocx`, body , this.httpOptions);
  }

  download_file(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' })
  }

  

  updateClasificationCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/company/updateClasificationCompany`, body , this.httpOptions);
  }

  updateStatusByCompanyCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/company/updateStatusByCompany`, body , this.httpOptions);
  }

  documentApprovalRequestApproved(body){
    return this.http.post(`${environment.baseUrlAPI}/company/documentApprovalRequest/approved`, body , this.httpOptions);
  }

  documentApprovalRequestObserve(body){
    return this.http.post(`${environment.baseUrlAPI}/company/documentApprovalRequest/observe`, body , this.httpOptions);
  }

  requiredFormatsSupplierStatus(body){
    return this.http.post(`${environment.baseUrlAPI}/company/requiredFormatsSupplier/status`, body , this.httpOptions);
  }

  supplierManagementRequests(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/requests`, body , this.httpOptions);
  }

  supplierManagementRequestsGraphic(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/requests/graphic`, body , this.httpOptions);
  }
  
  sendSupplierSapConfipetrol(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/sendConfipetrol`, body , this.httpOptions);
  }

  supplierManagementRequestApprovers(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/request/approvers`, body , this.httpOptions);
  }

  supplierManagementRequestDetail(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/request/detail`, body , this.httpOptions);
  }

  supplierManagementRequestApprove(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/request/approve`, body , this.httpOptions);
  }

  supplierManagementRequestObserve(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/request/observe`, body , this.httpOptions);
  }

  supplierManagementCreditReport(body){
    return this.http.put(`${environment.baseUrlAPI}/company/supplierManagement/creditReport`, body , this.httpOptions);
  }

  supplierManagementCreditReportPost(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/creditReport`, body , this.httpOptions);
  }

  supplierManagementCreditReportDelete(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/company/supplierManagement/creditReport`, httpOptionsTemp);
  }

  updateCategoryConfipetrol(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/request/updateCategoryConfipetrol`, body , this.httpOptions);
  }

  supplierManagementApproversDetail(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/approvers/detail`, body , this.httpOptions);
  }

  supplierManagementApproversUpdate(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/panel/request/approvers/update`, body , this.httpOptionsNew);
  }

  updateTagsSupplier(body){
    return this.http.post(`${environment.baseUrlAPI}/company/updateTagsSupplier`, body , this.httpOptions);
  }

  invoicePreference(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplierManagement/invoicePreference`, body , this.httpOptions);
  }

  //new 

  evaluationPanelSupplierDetail(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/supplier/detail`, body , this.httpOptionsNew);
  }

  panelRequestReviewers(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/panel/request/reviewers`, body , this.httpOptionsNew);
  }

  reviewersAdd(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/panel/request/reviewers/add`, body , this.httpOptionsNew);
  }

  reviewersRe(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/panel/request/reviewers/reassign`, body , this.httpOptionsNew);
  }

  reviewersDelete(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.sessionService.token}`
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPINEW}/company/panel/request/reviewers/delete`, httpOptionsTemp);
  }

  reviewersObserve(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/panel/request/reviewers/observe`, body , this.httpOptionsNew);
  }

  reviewersClearObservation(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/panel/request/reviewers/clearObservation`, body , this.httpOptionsNew);
  }

  reviewerscComment(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/panel/request/reviewers/comment`, body , this.httpOptionsNew);
  }
}